<template>
    <div v-if="isShow" class="product-card-container product-card-container_pdgbottom20">
        <div class="checked-statement">
            <div class="checked-circle"></div>
            <h2 class="checked-statement__statement">Отзывы</h2>
        </div>
        <div id="mc-container">
            <slot></slot>
        </div>
        <a id="mc-link" href="https://cackle.me">Комментарии для сайта <b style="color:#4FA3DA">Cackl</b><b style="color:#F65077">e</b></a>
    </div>
</template>

<script type="text/ecmascript-6">
export default {
    data() {
        return {

        }
    },
    props: ['isShow'],
    watch: {
        isShow: function() {
            if (this.isShow) {
                window.cackle_widget = window.cackle_widget || [];
                cackle_widget.push({widget: 'Comment', id: 28785});
                (function () {
                    var mc = document.createElement('script');
                    mc.type = 'text/javascript';
                    mc.async = true;
                    mc.src = ('https:' == document.location.protocol ? 'https' : 'http') + '://cackle.me/widget.js';
                    var s = document.getElementsByTagName('script')[0];
                    s.parentNode.insertBefore(mc, s.nextSibling);
                })();
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// productcomments.vue?c8350c1a